import gql from "graphql-tag"

import fullPaymentOrder from "@irati/payments/services/fragments/fullPaymentOrder"
import fullBasket from "@irati/checkout/services/fragments/fullBasket"
import fullDealRedemption from "./fullDealRedemption"
import fullDeal from "./fullDeal"

const fragment = gql`
  fragment fullPerksSaga on DealSaga {
    currentStep
    date
    errorData {
      day
      hour
      minute
      second
      number
      period
      value
      currency
      allowed
      openValueFrom
      openValueTo
    }
    errorCode
    errorLog
    errors
    nextStep
    paymentOrder {
      ...fullPaymentOrder
    }
    paymentOrderId
    redemption {
      fullDeal {
        ...fullDeal
        productConfig {
          products {
            vat
          }
        }
      }
      ...fullDealRedemption
    }
    status
    totalSteps
    updated
    uuid
    basket {
      ...fullBasket
    }
  }
  ${fullDeal}
  ${fullDealRedemption}
  ${fullPaymentOrder}
  ${fullBasket}
`

export const toString = fragment.loc.source.body

export default fragment
